module.exports = __webpack_public_path__ + "img/link.1c36741.png";